// @ts-ignore

// ts ignore is disabled because of the following error:

// Argument of type 'unknown' is not assignable to parameter of type 'Template<any, any>'.

import FeTextualDisplay from "@ebay/fe-textual-display/source/index.marko";

<if(FeTextualDisplay)>
  <FeTextualDisplay ...input on-click("handleClick")/>
</if>
